import {permissions} from './facebook-permissions';
import {FacebookSDKResponse} from '@domain/model/Auth/AuthLoginFaceBook';

export const loginWithFaceBook = async (): Promise<FacebookSDKResponse> =>
  new Promise((resolve, reject) =>
    FB.login(
      response => {
        if (response?.status === 'connected' && response?.authResponse?.accessToken) {
          // TODO maybe here we have to check other type of errors?
          const accessToken = response.authResponse.accessToken;
          const userId = response.authResponse.userID;
          resolve({accessToken, userId});
        } else {
          reject(new Error(`unable to login with fb status=${response.status}`));
        }
      },
      {scope: permissions.join(',')},
    ),
  );
